import userReducer from "./userReducer";
import OrganizationReducer from "./organizationReducer";
import loaderReducer from "./loaderReducer";
import aiServiceDetailsReducer from "./aiServiceDetailsReducer";
import aiServiceListReducer from "./aiServiceListReducer";
import errorReducer from "./errorReducer";
import hostingReducer from "./hostingReducer";
import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { userActions } from "../actionCreators";

const combinedReducer = combineReducers({
    user: userReducer,
    organization: OrganizationReducer,
    loader: loaderReducer,
    aiServiceDetails: aiServiceDetailsReducer,
    aiServiceList: aiServiceListReducer,
    hosting: hostingReducer,
    error: errorReducer,
});

const rootReducer = (state, action) => {
    if (action.type === userActions.loginActions.SIGNOUT) {
        return combinedReducer({ user: state?.user }, action);
    }

    return combinedReducer(state, action);
};

const store = configureStore({
    reducer: rootReducer,
});

export default store;
